import { datadogRum } from "@datadog/browser-rum";

// ENG-2067: LaunchDarkly's `flag-used` inspector fires on every flag read —
// thousands in the first seconds of a patient page — and Datadog init is
// deferred to an idle callback (index.tsx). Before init, RUM queues API calls
// in a buffer capped at 500 that drops the OLDEST call on overflow, so the
// flood evicted the `setUser` from `/me` and the whole page load was
// anonymous. Reads made before init are held here instead, one per flag
// (latest value wins), and handed to RUM once it has started.
const pendingEvaluations = new Map<string, unknown>();

export const recordFlagEvaluation = (key: string, value: unknown): void => {
  if (datadogRum.getInitConfiguration()) {
    datadogRum.addFeatureFlagEvaluation(key, value);
    return;
  }
  pendingEvaluations.set(key, value);
};

export const flushPendingFlagEvaluations = (): void => {
  pendingEvaluations.forEach((value, key) =>
    datadogRum.addFeatureFlagEvaluation(key, value)
  );
  pendingEvaluations.clear();
};
